import { useMemo } from "react";

import { useIntl } from "react-intl";

import ActivityVisibility from "@mapmycustomers/shared/enum/activity/ActivityVisibility";

import getVisibilityDisplayName from "@app/util/ui/getVisibilityDisplayName";

const useActivityVisibilityOptions = (
  isOwner: boolean = false,
  isManager: boolean = false
): { label: string; value: ActivityVisibility }[] => {
  const intl = useIntl();

  return useMemo(() => {
    const availableVisibilities: ActivityVisibility[] = isOwner
      ? [
          ActivityVisibility.SHARED_WITH_ORGANIZATION,
          ActivityVisibility.SHARED_WITH_TEAM,
          ActivityVisibility.PRIVATE,
        ]
      : isManager
        ? [ActivityVisibility.SHARED_WITH_TEAM, ActivityVisibility.PRIVATE]
        : [ActivityVisibility.PRIVATE];

    return availableVisibilities.map((visibility) => ({
      label: getVisibilityDisplayName(intl, visibility),
      value: visibility,
    }));
  }, [intl, isManager, isOwner]);
};

export default useActivityVisibilityOptions;
